module.exports = __webpack_public_path__ + "static/media/rm_06-11.386b93b1.png";